import cn from 'classnames'
import React from 'react'

import { ColumnActionUiEnum } from 'components/Editor/types'
import { scrollProps } from 'services/Scroll/ScrollService'
import { AppMode } from 'services/Store/Project/enums'
import { useProjectContext } from 'services/Store/Project/hooks'
import { getIsActiveNode, getIsHighlighted } from 'services/Store/Project/selectors'
import { t } from 'services/Translation'

import type { IAbsoluteProps } from '../../Node/types'
import ColumnControls from '../../controls/ColumnControls'
import ControlSelection from '../../controls/ControlSelection'
import * as s from './EditorAbsolute.module.scss'

const CONTROLS = [
  ColumnActionUiEnum.DELETE,
  ColumnActionUiEnum.SPLIT_HORIZONTAL,
  ColumnActionUiEnum.SPLIT_VERTICAL,
  ColumnActionUiEnum.ADD_SHELL,
]

const EditorAbsolute: React.FC<IAbsoluteProps> = ({ children, node, style, block, mode }) => {
  const isActive = useProjectContext(getIsActiveNode, node.id)
  const isHighlighted = useProjectContext(getIsHighlighted, node.id)
  const editorMode = mode.editorMode
  const isPro = editorMode === AppMode.pro
  const isFill = editorMode === AppMode.fill

  return (
    <div {...scrollProps(node.id)} className={cn(s.root, { [s.fillMode]: isFill })} style={style}>
      {children}
      {isActive && isPro && <ColumnControls block={block} controls={CONTROLS} nodeId={node.id} />}
      {(isActive || isHighlighted) && (
        <ControlSelection
          active={isActive}
          highlighted={isHighlighted}
          label={t('uiKit.tooltip.absolute')}
          name='colSelection'
        />
      )}
    </div>
  )
}

export default React.memo(EditorAbsolute)
